import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const JournalmasterAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		pbookid: yup.string().nullable().label($t('pbookid')),
		voucher_ref_no: yup.string().nullable().label($t('voucherRefNo')),
		transactiondate: yup.string().required().label($t('transactiondate')),
		narration: yup.string().nullable().label($t('narration')),
		posted: yup.number().required().label($t('posted')),
		cancelled: yup.number().nullable().label($t('cancelled'))
	});
	
	//form default values
	const formDefaultValues = {
		pbookid: '', 
		voucher_ref_no: '', 
		transactiondate: new Date(), 
		narration: '', 
		posted: "((0))", 
		cancelled: "((0))", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/journalmaster`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="JournalmasterAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewJournalmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pbookid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/pbookid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="pbookid"     optionLabel="label" optionValue="value" value={formik.values.pbookid} onChange={formik.handleChange} options={response} label={$t('pbookid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.pbookid)}   />
                                                    <ErrorMessage name="pbookid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('voucherRefNo')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="voucher_ref_no"  onChange={formik.handleChange}  value={formik.values.voucher_ref_no}   label={$t('voucherRefNo')} type="text" placeholder={$t('enterVoucherRefNo')}        className={inputClassName(formik?.errors?.voucher_ref_no)} />
                                                <ErrorMessage name="voucher_ref_no" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactiondate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="transactiondate" value={formik.values.transactiondate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.transactiondate)}        />
                                                <ErrorMessage name="transactiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('narration')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="narration"  onChange={formik.handleChange}  value={formik.values.narration}   label={$t('narration')} type="text" placeholder={$t('enterNarration')}        className={inputClassName(formik?.errors?.narration)} />
                                                <ErrorMessage name="narration" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('posted')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="posted"  onChange={formik.handleChange}  value={formik.values.posted}   label={$t('posted')} type="number" placeholder={$t('enterPosted')}  min={0}  step="any"    className={inputClassName(formik?.errors?.posted)} />
                                                <ErrorMessage name="posted" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('cancelled')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="cancelled"  onChange={formik.handleChange}  value={formik.values.cancelled}   label={$t('cancelled')} type="number" placeholder={$t('enterCancelled')}  min={0}  step="any"    className={inputClassName(formik?.errors?.cancelled)} />
                                                <ErrorMessage name="cancelled" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
JournalmasterAddPage.defaultProps = {
	primaryKey: 'transactionid',
	pageName: 'journalmaster',
	apiPath: 'journalmaster/add',
	routeName: 'journalmasteradd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default JournalmasterAddPage;
